import axios from "axios";
import { DataResponse } from "models/common/responseObjects";
import { GeneralSync } from "models/dbModels/syncSettings/ManagedStockSyncSettings";

export class SyncApi {
    static SyncChanges = async (query: GeneralSync) => axios.post<DataResponse<boolean>>(`api/v1/Sync/SyncChanges`, query);
}